require('./page.less');


var Backbone = require('backbone'),
    _ = require('underscore'),
    $ = require('jquery'),
    Spinner = require('spin.js'),
    CREImage = require('./creImage'),
    fvChannel = require('glRadio').channel('FV'),
    UnknownDimIndicator = require('./unknownDimIndicator/view'),
    pgDDButtonMarkup =  require('../markup/dropdownButton/bundle'),
    PageActionsDD = require('./pageActionDropdown/view'),
    PageErrorView = require('./error/view'),
    TextLayerView = require('./textLayer/view');

/**
 * A Page View Wrapper View Around CRE Image -- can be placeholder.
 * Evolved heavily over the years with a ton of hacks -- needs cleanup.
 * Image States:
 * - Not Requested (creRequest) --- essentially no styling: outline and background …
 * - Requested & Loading – request for CRE request (and then CRE request).…  spinner, loading labels
 * - Loaded (wasRequested from cre: true)
 * - Loaded – preImage Appended (change:isLoaded)
 * - Appended - Post Appended (change:isAppended)
 * - Error
 * - Revealed  ‘revealImage’) -- fade in ... hm
 * Hooks:
 * - before:ImageRequest
 * - before:EnterImgLoadingState
 * - before:ImageAppend
 * - before:renderError
 * - after:ImageAppend
 * Swapping templates, could also swap els (huh?)
 * Note: scale for doc and pg -- no i think just not thumb, pdf unrenderable (huh?)
 * TODO:
 *  - make this class into a Babysitter View / Marionette Region
 *  - a lot of this is evolved and can be cleaned up ... eg setting height & width on multiple divs
 *  - further subclassing
 */


module.exports = Marionette.ItemView.extend({

    className: 'FV-pgWr', // note: b/c unwrapped, replaced with template

    template: require('./page.hbs'),
    PageActionsDropDownView: PageActionsDD,

    FADEIN_TIMER: 400, // time in milliseconds to fade out the 'placeholder' post image load (can't be 0); 400 is the default for jQuery animations

    NON_LOADING: 0, // may encompass all below

    RENDER_LOADING_LABELS: 1, // flag to render the loading labels in the template ... only now turned off for thumbnails ... leave, may want elsewhere
    APPLY_TRANSFORM: 1, // override to not apply a transform -- eg unrenderable views ... TODO: more semantic, see with the other page types (non-image)?
    APPLY_SCALE: 1, // means apply scale to the outer div, would also imply there's a transform

    SUPPORTS_PAGE_TEXT_LAYER: 1,

    TEXT_LAYER_VIEW: TextLayerView,

    initialize: function(options) {

        _.extend( this, _.pick( options, 'model', 'vChannel', 'scale') );

        this.imgView = new CREImage(options);
        this.errorView = null;
        this.unknownDimensionsIndicatorView = null;

        this.creXHR = null;
        
        this.textLayerView = null;
    },

    // Note: for unknown dimensions page height, width are first approximated
    // (will see the approximates in the 'placeholder') until the actual size is derived and then updated

    // for now, height & width are use by similar views (thumbs, unrenderable)
    // for 'pages': we encapsulate setting all of that into the 'updateTransform' on render ( now: updateViewPort )
    // doesn't hurt here ... see how it plays with other view types ...

    //var originalDerivedDimensions = this.model.getDimensions();
    // TODO: put in template for clarifty?

    serializeData: function() {

        return {
            classNames: this.className, // put on template b/c of unwrap onRender -- TODO:  but  get rid of this
            pgNumber: this.model.get('number'),
            printWithDummyDimensions: this.model.resizePageFromDummyDimensionsPostLoad(),
            pgId: this.model.get('pageId'),
            includeLoadingLabels: this.RENDER_LOADING_LABELS,
            includeTextLayer: this._supportsPageTextLayer()
        };

    },

    onRender: function() {

        // note: small leak with loadingLabels ... should get rid of unwrap everywhere
        // TODO: rid
        this.unwrap();

        // I suppose could apply in template variables as well for clarity ...
        // same page types don't 'scale' -- here we just use a value of 1 in the calc's
        this.updateViewPort();

        // Note: former is hack to view creation on non-image views ( cleanup needed! )
        // ( the views won't be in the DOM (see serialize data ) but could still get created
        // note: apply_transform now has multiple meanings ...

        if ( this.APPLY_TRANSFORM && this.model.renderPrintPreviewIconOnPageImageViews() ) {

            this.unknownDimensionsIndicatorView = new UnknownDimIndicator({
                model: this.model
            });

            this.ui.unknownDimIndHolder.replaceWith( this.unknownDimensionsIndicatorView.render().el );

        }

        // Print on render, not load
        if ( this.NON_LOADING ) {
            this._createPageActionDropDown();
        }

        // No scale/rotate transform will be applied, have transformedWr
        // TODO: better way to accomplish ... eg now the could also just not print this div (eg url doesn't need); markup thumbs don't have ...
        // - need to map out and plan similarieties
        if ( !this.APPLY_TRANSFORM ) {
            this.ui.transformedWr &&
                this.ui.transformedWr.addClass('noTransform');
        }

        if ( this._includeTextLayer() )
            this._createTextLayer();

        if ( this._applyTextOnlyMode() ) {
           this._toggleTextOnlyMode(true);
        }


    },
    /**
     * Use model to communicate between views
     */
    modelEvents: {
        'creRequest':           'requestImg', // Triggering from the view mode container (typically)
        'change:wasRequested':  'enterLoadingState', // really: 'queued' in CRE
        'change:isLoaded':      'enterImageLoaded',
        'imgLoadError':         'enterLoadError',
        'page:cancelLoad':      'abort',
        'pageView:rotate':      'rotate', // For now the same as scale, but left as separate currently for differentiation
        'pageView:showFindAndRedactHits':   'showFindAndRedactHits',
        'pageView:toggleTextLayer':         '_toggleTextLayer',
        'pageView:toggleTextOnlyMode':      '_toggleTextOnlyMode'

    },
    ui: {
        innerWr:                '.FV-pg-inner-wr', // wraps all layers, and allows to position them atop
        placeHolder:            '.FV-pg-loading-placeholder',
        transformedWr:           '.FV-pg-transform-wr', // layer that is transformed; contains image and text layer, not canvas
        canvasPlaceholder:      '[data-canvas-holder]', // may or may not have -- note: if Cold with img overlay -- put canvas inside the overlay (just pg mode?)
        imageHolder:            '[data-img-stub]', // replaced with imgView
        unknownDimIndHolder:    '[data-unknown-dim-ind-stub]',
        dropDownStub:           '[data-page-dd-stub]',
        loadingLabels:          '.FV-imgLoading-label',
        textLayerHolder:          '[data-text-layer-holder]'
    },

    /* Whether to print the placeholder DIV to the template at all; text can be toggled on off */
    _supportsPageTextLayer: function() {
        return this.SUPPORTS_PAGE_TEXT_LAYER && this.model.isFddImage();
    },
    
    _includeTextLayer: function() {

        return this._supportsPageTextLayer() && this._pageHasPositionalTextData() &&
            this.vChannel.request('showPageTextMode');
    },

    _applyTextOnlyMode: function() {

        return this._supportsPageTextLayer() && this._pageHasPositionalTextData &&
            this.vChannel.request('textOnlyMode');

    },

    _pageHasPositionalTextData: function() {

        // Only defined on doc mode models
        if ( this.model.hasPositionalTextData )
            return this.model.hasPositionalTextData();

        // Handle page mode -- could use both for the above
        return this.vChannel.request( 'pageHasPositionTextModel', this.model.get('number') );

    },

    _getPositionalTextModel: function() {

        if ( this.model.getPositionalTextDataModel )
            return this.model.getPositionalTextDataModel();

        return this.vChannel.request( 'getPagePositionalTextModel', this.model.get('number') );

    },

    _toggleTextLayer: function( show ) {

        // Check in case -- this toggle is fired on a page types
        if ( !this._supportsPageTextLayer() )
            return;

        // For now just a toggle --> ignoring show parameter
        !this.textLayerView
            ? this._createTextLayer()
            : this._removeTextLayer();

    },

    _toggleTextOnlyMode: function( enter ) {

        if ( !this._supportsPageTextLayer() )
            return;

        this.$el.toggleClass( 'textOnlyMode', enter );


    },

    _createTextLayer: function() {

        if ( !this._includeTextLayer() )
            return;

        this.textLayerView = new this.TEXT_LAYER_VIEW({
            page: this.model,
            pagePositionalTextModel: this._getPositionalTextModel()
        });

        // Leave the holder in place, will need to reappend with toggle functionality
        // Later migrate this to a layout view with regions
        this.ui.textLayerHolder.append( this.textLayerView.render().el );

        this.$el.addClass('showTextMode');

    },

    _removeTextLayer: function() {

        this.$el.addClass('showTextMode');

        this.textLayerView && this.textLayerView.destroy(); // If toggle on/off maybe better way to cache?
        this.textLayerView = null;

    },


    // Now trying utilizing existing text layer if it exists ...
    // Not sure if we want to show hits in this mode .... could be helpful ....
    showFindAndRedactHits: function( searchResults ) {

      /*  if ( this.textLayerView ) {
            this.textLayerView.showFindAndRedactHits( searchResults.getResultsForPage( this.model.get('number')) );
        }*/

    },

    rotate: function() {
        this.updateViewPort();
    },

    /**
     * The entry point of the 'image'/'url' load cycle.
     * Note: can be for overlay of the regular image in case of COLD.
     * Can also be the iframe source url for GOS-PDF pages.
     * If NON_LOADING, not applicable, so return;
     */
    requestImg: function(overlayAddress) {


        if ( this.NON_LOADING ) {
            return;
        }

        var pm = this.model,
            imgView = this.imgView,
            self = this;

        pm.off('creRequest');
        this.triggerMethod('before:ImageRequest');

        // Should prevent prior to call ...
        if ( pm.get('isLoaded' ))
            return;


        var fvSettings = fvChannel.request('settings'),
            imageRenderRequest = overlayAddress         // TODO: subclass & breakout
                ? pm.getOverlayImageRequest(overlayAddress)
                : pm.getImgRenderRequest();


        this.creXHR = $.fn.creRequest( _.extend( {}, imageRenderRequest, {

            onStart: _.bind(pm.set, pm, {'wasRequested': true}),
            onComplete: function(creResp) {

                /* store here for now -- could just send the url here base on the model type -- eg inlineUrl or imageUrl*/
                pm.creResp = creResp;

                imgView.el !== null && // temp fix switching too fast
                    imgView.loadImg( self._getCreUrlToLoad( creResp) );
            },

            onError: _.bind( self.enterLoadError, self ),
            fileName: self._getCRERequestFileName(),

            /* TODO: store defaults on FV to merge with -- with cre req queue should be one place to call */
            CRE_ROOT: fvSettings.getCRERoot(),
            POLL_FREQ: fvSettings.crePollInterval
        }));


    },

    _getCreUrlToLoad: function( creResponse ) {
        return creResponse['imgUrl'];
    },

    _getCRERequestFileName: function() {
        return this.model.getCreImgRequestFileName();
    },

    // TODO: prevent at onset .. this covers page types not inheriting (eg url)
    abort: function() {
        this.creXHR && this.creXHR.cancel();
    },

    enterLoadingState: function() {

        this.model.off('change:wasRequested');
        this.triggerMethod('before:EnterImgLoadingState');
        this.spinner = new Spinner( this.model.getSpinJSOptions() ).spin(this.el);

    },
    /**
     * DOM manipulation necessary to due to need to maintain height and position --
     * -- other alternative: a region with swapped views... but heavy
     */
    enterImageLoaded: function() {

        this.model.off('change:isLoaded');

        if ( this.vChannel.request('disableImageDownloads') ) {
            this._disableContextMenu();
        }

        this._postImgLoadOfPageWithUnknownDimensions();

        this._stopSpinner(); //  why not put in before image append?
        this.triggerMethod('before:ImageAppend');

        //(image loaded but not yet in DOM) --> append so it takes up same space (has same outline as the placeholder)
        this._appendImageView();

        this._createPageActionDropDown();

        this.triggerMethod('after:ImageAppend');

    },

    /** Override as noop if there's nothing to append -- eg cold pages without overlays **/
    _appendImageView: function() {

        this.ui.imageHolder.replaceWith( this.imgView.$el );
    },

    /**
     * The image has been downloaded, (though hidden) set the actual size of 'unknownDimension' images to the actual size of the image.
     * Note:
     * - on pages with 'unknown dimensions', rotation doesn't apply.
     * - for now not a separate class.
     * - doesn't imply COLD text pg -- dims there are the paper ( resizePageFromDummyDimensionsPostLoad )
     * This is likely now a command that should go higher up ...
     * Url page types:
     * - can't get the size if on diff domain / iframe sandbox attribute set
     * - if can access the contents to get the size on load, will need to refactor so that iframe is loaded in the DOM, to catch it's 'load' event
     * Also then scale the dimensions to fit the viewer container size and current scale:
     * - need to update the scale model for the calculations b/f setting the dimensions of the view
     * - ... still necessary ... the scale will not have been changed since loaded ???
     * TODO:
     * - should have higher level way of doing this in WF, eg: should need to rescale the thumb
     * - document mode -- load if not threshold && update the vOffsets
     */
    _postImgLoadOfPageWithUnknownDimensions: function() {

        if ( !this.model.resizePageFromDummyDimensionsPostLoad() )
            return;

        // weird, it's actually not loaded yet ... ?
        var actualImgDims = this._getActualImgDimensionsPreLoad();
        this.model.updateUnknownDimensionsPostLoad( actualImgDims );

        this.options.vChannel.command('setScale');

        // Redundant in some page types after updating setScale ??? -- maybe
        this.updateViewPort();

    },

    /**
     * DVBC-1713 - disable context menu over images to limit users from being
     * able to right click, download.
     * Currently not putting on the CRE Image -- in page mode this is a layer behind the canvas,
     * so the event will not get caught.
     * The innerWr div wraps the image and the canvas, so for our purpose it's essentially the same
     * as blocking on the image.  This also won't block an error view, so the user can still access
     * the dropdown to select text from there.
     * Note: only called if the user lack permission after a successful load
     */
    _disableContextMenu: function() {

        this.ui.innerWr.on('contextmenu', function(e) {

            e.preventDefault();
        });

    },

    _createPageActionDropDown: function() {

        this.ui.dropDownStub.replaceWith( pgDDButtonMarkup );
        this.pageDDView = new this.PageActionsDropDownView( this._getActionDropDownOptions() ).render();

    },
    _getActionDropDownOptions: function() {
        return {
            el: this.$('.page-dd'),
            model: this.model,
            vChannel: this.options.vChannel
        };
    },

    /**
     *  Note:
     *  - putting in the DOM will trigger a request -- may not be desirable
     *  - DVBC-1818: !if browser cache is disabled, this will not work! ( even though image was
     *  already loaded, the plugin will not load it from the cache, the call would be async, & this wouldn't be accurate).
     *  For clarity, if/when needed, could alter plugin fn to take this into account.
     */
    _getActualImgDimensionsPreLoad: function() {

        var $imgEl = this.imgView.$el;

        var actualDims = $imgEl.getHiddenElementDimensions({
            removeInlineDimensions: true,
            $container: this.options.vChannel.request('getWrapper'), // cache? -- it's offset the screen so don't put in rel. container
            useOuter: false,
            removeClass: $imgEl.attr('class') // ( in case any width / height would be on there )
        });

        return actualDims;

    },

    /* Note: overwritten by page mode to create canvas */
    onAfterImageAppend: function() {

        this._reveal().done( function() {
             this.triggerMethod('afterImgRevealed');
        });

    },

    /**
     * Dfd b/c of fade.
     * Note: self.FADEIN_TIMER can't be 0; if it is, jQuery UI falls back to the normal
     * addClass, which doesn't include a callback and this callback will never be called.
     */
    _reveal: function() {

        var $placeholder = this.ui.placeHolder,
            self = this;

        return $.Deferred(function($dfd) {
            $placeholder.addClass( 'noOpacity', self.FADEIN_TIMER , function() {
                 $placeholder.remove();
                 $dfd.resolveWith(self);
             });

        });

    },
    /*
    * From CRE or 'Loading' Image -- latter will be an event.
    * */
    enterLoadError: function(errMsg) {

        this.model.set( 'loadError', true, {silent: true} ); //should have this occur as result of setting the attr
        this.model.off( 'imgLoadError' );
        Marionette.triggerMethodOn( this.imgView, 'abortImageRequestOnErr' ); // turn off events, req loop

        // First check if 401 (user timed out) -- if so, not an image error -- redirect to login state
        fvChannel.request('auth')._keepAlive().then( _.bind( function(isAuthenticated) {

            isAuthenticated
                ?  this._renderError(errMsg) // regular error
                : fvChannel.request('auth').setUserAuth(false); //set state to auth screen: user timed out

        }, this));

    },
    /**
     * Inserted into the placeHolder (same where image goes )
     */
    _renderError: function(errMsg) {

        this._stopSpinner();

        this.unknownDimensionsIndicatorView && this.unknownDimensionsIndicatorView.destroy();

        this.imgView.destroy();
        this.triggerMethod('before:renderError');
        this._appendErrorViewInDOM(errMsg);
        this._createPageActionDropDown();
    },

    _appendErrorViewInDOM: function(errMsg) {

        this.errorView = new PageErrorView({
            errMsg: errMsg
        });

        this.ui.placeHolder.replaceWith( this.errorView.render().el );

    },

    // Previous just reflected an update in scale, but now scale and rotation
    // For certain page types that can't be rotated, will just scale.
    updateViewPort: function() {

        if ( !this.APPLY_SCALE )
            return;

        var originalDerivedDimensions = this.model.getDimensions();

        var r = this.model.get('rotation'); // Note: rotation N/A for all page types -- see APPLY_TRANSFORM

        var s = this.scale
            ? this.scale.getScaleValue()
            : 1; // For page types that don't have scale ( thumbs, see if others ) -- just set to the derived dimensions

        var w = originalDerivedDimensions.width; // not necessarily the originals; can be requested differently, eg in doc mode
        var h = originalDerivedDimensions.height;

        // It we are off by the requested width and height when rotated 90, 270 ...
        // when don't request the actual image size ... ( this.get('width') )

        if (r !== 90 && r !== 270 ) {

            this.$el.css({
                height: Math.round(h * s), // Round stops jumpiness on scroll !
                width: Math.round(w * s)
            });

        } else {

            this.$el.css({
                height: Math.round(w * s),
                width: Math.round(h * s)
            });

        }

        if ( this.APPLY_TRANSFORM ) {

            this.ui.transformedWr.css({
                height: h,
                width: w,
                transform: this._getTransform(s, r, w, h)
            });

        }

        // For now canvas is handled in page mode for clarify ( only done there ) ...

    },

    _getTransform: function( s, r, w, h ) {

        var t  = '';

        var sTransform = 'scale(' + s + ')';
        var rTransform = 'rotate(' + r + 'deg)';

        var tx = 0,
            ty = 0;

        if ( r === 90 )
        {
            tx = h;
            ty = 0;
        } else if ( r === 180 ) {
            tx = w;
            ty = h;
        } else if ( r === 270 ) {
            tx = 0;
            ty = w;
        }

        var tTransform = 'translate(' + tx + 'px, ' + ty + 'px)';

        // Only apply the scale if it exists -- doesn't for some types like thumbnails
        (s != 1) &&
            (t = sTransform);

        (r != 0) &&
            (t += ' ' + tTransform + ' ' + rTransform);

        return t;

    },

    // TODO: I think want this on on before image append ( where we also rid the loading labels )
    // though it's called from other places
    // predicate in case to prevent run time errors ( in case forgot in a page type )
    _stopSpinner: function() {
        this.spinner && this.spinner.stop();
    },

    // Shows the loading labels (removes the hidden div -- revealing the other elements lbl elements )
    // ( if they exist )
    onBeforeEnterImgLoadingState: function() {

        this.ui.loadingLabels  && this.ui.loadingLabels.unwrap();
    },

    onBeforeImageAppend: function() {
        this.ui.loadingLabels && this.ui.loadingLabels.remove();
    },
    onBeforeRenderError: function() {
        this.ui.loadingLabels.remove();
        this.options.vChannel.command('pageImgLoadError', this.model);
    },

    onBeforeDestroy: function() {

        // remove the context menu listener if it was applied on load
        this.ui.innerWr.off();

        // Could move to page mode ..
        if (this.canvas) {
            //this.unwireCommunicationWithCanvas();
            this.canvas.destroy();
        }

        this.unknownDimensionsIndicatorView && this.unknownDimensionsIndicatorView.destroy();

        this.errorView && this.errorView.destroy();

        // DVBC-1449 -- If page loaded in error, the image view was already destroyed,
        // so calling destroy again will result in a runtime error.
        !this.model.imgLoadFailed() && this.imgView.destroy();

        this.pageDDView && this.pageDDView.destroy();

        this.textLayerView && this._removeTextLayer();

        // need to remove/destroy the spinner ?

        this.off();
        this.$el.off(); // plugins (in case of plugins) -- eg inview
        this.stopListening();


    },

    destroy: function() {
        Marionette.ItemView.prototype.destroy.apply(this, arguments);
        this.el = null;
        this.$el = null;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/page.js
 ** module id = 418
 ** module chunks = 0
 **/